import { Component, EventEmitter } from '@angular/core';
import { ArticleSourceRecord } from 'app/_models/common/article-source/article.source.record';
import { ArticleSourceSearchRequest } from 'app/_models/common/article-source/article.source.search.request';
import { VrooamCABGroupInfo } from 'app/_models/common/article-source/vrooam.cab.group.info';
import { AdminService } from 'app/_services/admin/admin.service';
import { MainService } from 'app/_services/main.service';
import { Observable } from 'rxjs';
import { ArticleSourceCompareComponent } from '../admin-item-info/article-source-response/article-source-compare/article-source-compare.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ArticleSourceResponseDialogComponent } from './article-source-response-dialog/article-source-response-dialog.component';

@Component({
  selector: 'app-admin-cab-info',
  templateUrl: './admin-cab-info.component.html',
  styleUrl: './admin-cab-info.component.scss'
})
export class AdminCabInfoComponent {
  groups: string;
  groupInfos: VrooamCABGroupInfo[];
  busy = false;
  focusInput = new EventEmitter<boolean>();
  busyArticleSourceSearch: boolean;
  articleSourceSearchResponse: ArticleSourceRecord[];
  keys: string[];
  dateKeys = ['HistoryTimestamp', 'Datetime', 'Created', 'LastChecked', 'LastUpdated'];
  hideKeys = ['History', 'Errors'];
  pageNumber = 1;
  pageSize: number | 'all' = 25;
  pageSizeOptions: Array<number | 'all'> = [10, 25, 50, 100, 'all'];

  constructor(
    private adminService: AdminService,
    private mainService: MainService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.focusInput.emit(true);
    }, 0);
  }

  getGroupInfo(groups: string) {
    this.busy = true;
    this.adminService.articleSourceSearchGroupInfo(groups)
      .subscribe(response => {
        this.groupInfos = response;
        this.busy = false;
      });
  }

  getKeys(item: ArticleSourceRecord): string[] {
    return Object.keys(item).filter(key => !this.hideKeys.includes(key));
  }

  get totalPages(): number {
    const totalRecords = this.articleSourceSearchResponse?.length ?? 0;
    if (!totalRecords) {
      return 1;
    }

    if (this.pageSize === 'all') {
      return 1;
    }

    return Math.ceil(totalRecords / this.pageSize);
  }

  get pagedArticleSourceSearchResponse(): ArticleSourceRecord[] {
    if (!this.articleSourceSearchResponse?.length) {
      return [];
    }

    if (this.pageSize === 'all') {
      return this.articleSourceSearchResponse;
    }

    const startIndex = (this.pageNumber - 1) * this.pageSize;
    return this.articleSourceSearchResponse.slice(startIndex, startIndex + this.pageSize);
  }

  get pageNumbers(): number[] {
    return Array.from({ length: this.totalPages }, (_, index) => index + 1);
  }

  get visiblePageSizeOptions(): Array<number | 'all'> {
    const totalRecords = this.articleSourceSearchResponse?.length ?? 0;

    if (!totalRecords) {
      return ['all'];
    }

    const numberOptions = this.pageSizeOptions
      .filter((size): size is number => typeof size === 'number' && size < totalRecords);

    return [...numberOptions, 'all'];
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.pageNumber = page;
  }

  onPageSizeChange(): void {
    this.pageNumber = 1;
  }

  openArticleSourceResponse(item: ArticleSourceRecord): void {
    const initialState = {
      response: [item]
    };

    this.modalService.show(ArticleSourceResponseDialogComponent, { initialState, class: 'modal-max' });
  }

  normalizePageSize(): void {
    const totalRecords = this.articleSourceSearchResponse?.length ?? 0;

    if (!totalRecords) {
      this.pageSize = 'all';
      this.pageNumber = 1;
      return;
    }

    if (this.pageSize !== 'all' && this.pageSize >= totalRecords) {
      const numberOptions = this.pageSizeOptions
        .filter((size): size is number => typeof size === 'number' && size < totalRecords);
      this.pageSize = numberOptions.length ? numberOptions[numberOptions.length - 1] : 'all';
      this.pageNumber = 1;
    }
  }

  isDateKey(key: string): boolean {
    return this.dateKeys.includes(key);
  }

  articleSourceSearch(groupInfo: VrooamCABGroupInfo) {
    this.busyArticleSourceSearch = true;
    this.articleSourceSearchResponse = null;
    const request = new ArticleSourceSearchRequest();
    request.Culture = groupInfo.Culture;
    request.MaxResults = 0;
    request.WithHistory = true;
    request.AllItemsMustMatch = true;
    request.ItemGroup = +groupInfo.VrmGroupNumber;
    request.SupplierCode = groupInfo.SupplierCode;
    request.SupplierGroup = groupInfo.SupplierGroup;

    this.adminService.articleSourceSearch(request)
      .subscribe(response => {
        if (response?.length > 0) {
          this.articleSourceSearchResponse = response;
          this.keys = this.getKeys(response[0]);
          this.pageNumber = 1;
          this.normalizePageSize();
        } else {
          this.articleSourceSearchResponse = [];
          this.keys = [];
          this.pageNumber = 1;
          this.normalizePageSize();
        }
        this.busyArticleSourceSearch = false;
      });
  }

   articleSourceCompare(item: ArticleSourceRecord): Observable<boolean> {
        const initialState = {
          item: item,
          mainService: this.mainService
        };
        const modalRef = this.modalService.show(ArticleSourceCompareComponent, { initialState, class: 'modal-max' });
        return modalRef.content.onClose;
      }
  

}
